module.exports = __webpack_public_path__ + "img/kasten-gruen.9a3d722.png";